import React from 'react'
import { FuseSplashScreen } from '@fuse'
import { useRefreshTokenOnLaunch } from './authHooks'

export default ({ children }) => {
  const waitAuthCheck = useRefreshTokenOnLaunch()
  return waitAuthCheck ? <FuseSplashScreen /> : children
}
